module.exports = {
	"_from": "elliptic@^6.2.3",
	"_id": "elliptic@6.4.1",
	"_inBundle": false,
	"_integrity": "sha512-BsXLz5sqX8OHcsh7CqBMztyXARmGQ3LWPtGjJi6DiJHq5C/qvi9P3OqgswKSDftbu8+IoI/QDTAm2fFnQ9SZSQ==",
	"_location": "/elliptic",
	"_phantomChildren": {},
	"_requested": {
		"type": "range",
		"registry": true,
		"raw": "elliptic@^6.2.3",
		"name": "elliptic",
		"escapedName": "elliptic",
		"rawSpec": "^6.2.3",
		"saveSpec": null,
		"fetchSpec": "^6.2.3"
	},
	"_requiredBy": [
		"/browserify-sign",
		"/create-ecdh",
		"/secp256k1"
	],
	"_resolved": "https://registry.npmjs.org/elliptic/-/elliptic-6.4.1.tgz",
	"_shasum": "c2d0b7776911b86722c632c3c06c60f2f819939a",
	"_spec": "elliptic@^6.2.3",
	"_where": "/home/marko/EthereumAsyncProjects/AsyncCoinContract/node_modules/secp256k1",
	"author": {
		"name": "Fedor Indutny",
		"email": "fedor@indutny.com"
	},
	"bugs": {
		"url": "https://github.com/indutny/elliptic/issues"
	},
	"bundleDependencies": false,
	"dependencies": {
		"bn.js": "^4.4.0",
		"brorand": "^1.0.1",
		"hash.js": "^1.0.0",
		"hmac-drbg": "^1.0.0",
		"inherits": "^2.0.1",
		"minimalistic-assert": "^1.0.0",
		"minimalistic-crypto-utils": "^1.0.0"
	},
	"deprecated": false,
	"description": "EC cryptography",
	"devDependencies": {
		"brfs": "^1.4.3",
		"coveralls": "^2.11.3",
		"grunt": "^0.4.5",
		"grunt-browserify": "^5.0.0",
		"grunt-cli": "^1.2.0",
		"grunt-contrib-connect": "^1.0.0",
		"grunt-contrib-copy": "^1.0.0",
		"grunt-contrib-uglify": "^1.0.1",
		"grunt-mocha-istanbul": "^3.0.1",
		"grunt-saucelabs": "^8.6.2",
		"istanbul": "^0.4.2",
		"jscs": "^2.9.0",
		"jshint": "^2.6.0",
		"mocha": "^2.1.0"
	},
	"files": [
		"lib"
	],
	"homepage": "https://github.com/indutny/elliptic",
	"keywords": [
		"EC",
		"Elliptic",
		"curve",
		"Cryptography"
	],
	"license": "MIT",
	"main": "lib/elliptic.js",
	"name": "elliptic",
	"repository": {
		"type": "git",
		"url": "git+ssh://git@github.com/indutny/elliptic.git"
	},
	"scripts": {
		"jscs": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
		"jshint": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
		"lint": "npm run jscs && npm run jshint",
		"test": "npm run lint && npm run unit",
		"unit": "istanbul test _mocha --reporter=spec test/index.js",
		"version": "grunt dist && git add dist/"
	},
	"version": "6.4.1"
};


//////////////////
// WEBPACK FOOTER
// ./~/elliptic/package.json
// module id = 430
// module chunks = 0